import { Typography } from "@mui/material";

const BookedByPatientMark = () => (
  <Typography
    component="span"
    sx={{
      ml: 0.5,
      fontSize: "0.62rem",
      lineHeight: 1.1,
      fontWeight: 700,
      color: "#0B78D0",
      whiteSpace: "nowrap",
    }}
  >
    Booked by patient
  </Typography>
);

export default BookedByPatientMark;
